var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 308,
    height: 44,
    viewBox: "0 0 308 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.1255 5.67087H57.9652L67.3102 21.9919L57.9732 38.3292H63.1255L72.4706 21.9919L63.1255 5.67087Z",
    fill: "#ED9429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4893 38.3292L5.15228 22L14.5054 5.67087H9.35312L0 22L9.337 38.3292H14.4893Z",
    fill: "#ED9429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8217 0.00814819L36.2514 22L48.8378 43.9756L61.392 22L48.8217 0.00814819Z",
    fill: "#624D42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4107 6.16718C98.1514 6.16718 101.546 11.4394 101.546 16.7441C101.546 22.0488 98.1514 27.2397 91.4107 27.2397H84.5329V37.7352H79.9854V6.16718H91.4107ZM91.4107 22.6916C95.2003 22.6916 97.0548 19.7219 97.0548 16.7522C97.0548 13.7826 95.1761 10.7641 91.4107 10.7641H84.5329V22.6916H91.4107Z",
    fill: "#34A33D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.528 21.7071H117.793C118.529 21.7512 119.266 21.6407 119.958 21.3825C120.65 21.1243 121.281 20.7241 121.811 20.2072C122.342 19.6902 122.76 19.0678 123.04 18.3792C123.32 17.6907 123.455 16.9511 123.437 16.2071C123.437 13.5059 121.566 10.7641 117.793 10.7641H110.875V37.6945H106.432V6.16718H117.817C124.598 6.16718 127.993 11.2116 127.993 16.2071C128.052 18.5316 127.264 20.7972 125.777 22.5743C124.291 24.3514 122.21 25.5164 119.93 25.8484L129.799 37.6945H123.945L112.568 23.8632L112.528 21.7071Z",
    fill: "#34A33D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.096 10.3979C137.586 8.8725 139.361 7.66117 141.319 6.83437C143.277 6.00757 145.379 5.58179 147.501 5.58179C149.624 5.58179 151.725 6.00757 153.683 6.83437C155.641 7.66117 157.417 8.8725 158.906 10.3979C161.908 13.4726 163.59 17.6151 163.59 21.9308C163.59 26.2465 161.908 30.3891 158.906 33.4637C157.417 34.9892 155.641 36.2005 153.683 37.0273C151.725 37.8541 149.624 38.2799 147.501 38.2799C145.379 38.2799 143.277 37.8541 141.319 37.0273C139.361 36.2005 137.586 34.9892 136.096 33.4637C133.095 30.3891 131.412 26.2465 131.412 21.9308C131.412 17.6151 133.095 13.4726 136.096 10.3979ZM155.649 13.6524C154.582 12.5582 153.311 11.6885 151.909 11.0935C150.507 10.4986 149.002 10.1903 147.481 10.1864C145.976 10.1925 144.487 10.5023 143.103 11.0975C141.718 11.6928 140.465 12.5614 139.418 13.6524C138.342 14.7327 137.488 16.017 136.905 17.4314C136.323 18.8458 136.023 20.3625 136.023 21.8942C136.023 23.426 136.323 24.9426 136.905 26.357C137.488 27.7714 138.342 29.0557 139.418 30.1361C140.464 31.2285 141.717 32.0987 143.102 32.6953C144.486 33.2919 145.975 33.603 147.481 33.6102C149.754 33.5774 151.968 32.8723 153.848 31.5825C155.728 30.2926 157.192 28.4745 158.058 26.3535C158.924 24.2324 159.154 21.9016 158.72 19.6498C158.286 17.3979 157.207 15.324 155.617 13.6849L155.649 13.6524Z",
    fill: "#34A33D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.376 17.3787C192.078 12.2041 187.167 10.3084 183.104 10.3084C176.855 10.3084 172.033 15.1901 172.033 21.9756C172.033 28.7611 176.871 33.7729 183.104 33.7729C187.03 33.7729 191.231 31.926 193.102 27.2641H181.322V22.6021H198.504C198.278 25.3114 198.06 27.1095 197.609 28.1916V28.1428C195.424 34.2692 188.909 38.2315 183.095 38.2315C174.17 38.2315 167.429 31.4297 167.429 21.9593C167.429 12.4889 174.307 5.68713 183.095 5.68713C189.215 5.68713 196.577 8.8358 198.27 17.395L193.376 17.3787Z",
    fill: "#34A33D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.728 6.19156V37.7189H204.261V6.19156H208.728ZM209.575 20.8365L220.468 6.19156H226.047L214.13 21.8617L227.297 37.7189H221.492L209.575 23.1228V20.8365Z",
    fill: "#E5842D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.237 10.5769H242.431V33.358H248.237V37.7271H232.111V33.358H237.916V10.5769H232.111V6.23224H248.237V10.5769Z",
    fill: "#E5842D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.871 6.23224C276.095 6.23224 281.19 14.1161 281.19 22C281.19 29.8839 276.062 37.7189 265.871 37.7189H254.663V6.23224H265.871ZM265.871 33.1708C273.127 33.1708 276.764 27.5814 276.764 22C276.764 16.4186 273.103 10.7803 265.871 10.7803H259.178V33.1708H265.871Z",
    fill: "#E5842D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.695 14.3439C302.066 11.5044 299.034 10.2759 296.309 10.3328C294.212 10.3735 291.89 11.0976 290.664 12.7167C290.052 13.5605 289.781 14.6077 289.907 15.6457C290.124 18.9001 293.656 19.2988 297.002 19.608C301.284 20.1531 306.597 21.2352 307.807 26.3203C307.935 27.0043 308.003 27.6987 308.008 28.395C308.008 34.4726 302.033 37.9874 296.405 37.9874C291.568 37.9874 285.738 35.1073 285.117 29.4771L285.069 28.6146L289.624 28.5252L289.673 29.2004V29.0215C289.979 31.9504 293.511 33.48 296.413 33.48C299.76 33.48 303.42 31.5925 303.42 28.3462C303.412 27.9816 303.367 27.6189 303.283 27.2641C302.751 24.8802 299.534 24.4734 296.413 24.1561C291.576 23.6598 285.835 22.5858 285.343 16.02V16.0688C285.136 13.9284 285.741 11.7884 287.036 10.0806C289.133 7.33062 292.882 5.89053 296.502 5.89053C301.34 5.89053 306.315 8.41272 307.121 14.1731L302.695 14.3439Z",
    fill: "#E5842D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.392 22.0244L11.0947 22.0163L14.2393 16.5163H20.5365L17.392 22.0244Z",
    fill: "#008F41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6811 22.0244H17.392L20.5366 16.5163L26.8338 16.5244L23.6811 22.0244Z",
    fill: "#34A33D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9784 22.0244H23.6812L26.8338 16.5244H33.131L29.9784 22.0244Z",
    fill: "#95BC2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2756 22.0244H29.9784L33.131 16.5244L39.4202 16.5326L36.2756 22.0244Z",
    fill: "#30A966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5366 16.5163H14.2393L17.392 11.0163H23.6892L20.5366 16.5163Z",
    fill: "#30A966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8338 16.5244L20.5366 16.5163L23.6892 11.0163L29.9864 11.0244L26.8338 16.5244Z",
    fill: "#95BC2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.131 16.5244H26.8338L29.9864 11.0244H36.2756L33.131 16.5244Z",
    fill: "#008F41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4202 16.5326L33.131 16.5244L36.2756 11.0244H42.5728L39.4202 16.5326Z",
    fill: "#95BC2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6892 11.0163H17.392L20.5446 5.51627L26.8338 5.5244L23.6892 11.0163Z",
    fill: "#008F41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9864 11.0244L23.6892 11.0163L26.8338 5.52441H33.131L29.9864 11.0244Z",
    fill: "#30A966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2756 11.0244H29.9865L33.131 5.52441H39.4283L36.2756 11.0244Z",
    fill: "#34A33D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5728 11.0244H36.2756L39.4283 5.52441H45.7255L42.5728 11.0244Z",
    fill: "#30A966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8338 5.5244L20.5446 5.51627L23.6892 0.0162659L29.9864 0.024402L26.8338 5.5244Z",
    fill: "#95BC2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.131 5.52441H26.8338L29.9864 0.0244141H36.2837L33.131 5.52441Z",
    fill: "#008F41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4282 5.52441H33.131L36.2837 0.0244141H42.5809L39.4282 5.52441Z",
    fill: "#95BC2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7255 5.52441H39.4283L42.5809 0.0244141L48.8701 0.0325502L45.7255 5.52441Z",
    fill: "#34A33D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2272 22.0081L11.0706 22.0163L23.657 44L48.8136 43.9837L36.2272 22.0081Z",
    fill: "#7B6A59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3678 22.0081H11.0706L14.2151 27.5082H20.5124L17.3678 22.0081Z",
    fill: "#34A33D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.657 22.0081H17.3678L20.5124 27.5082H26.8096L23.657 22.0081Z",
    fill: "#008F41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9542 22L23.657 22.0081L26.8096 27.5081L33.1068 27.5L29.9542 22Z",
    fill: "#30A966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2514 22H29.9542L33.1068 27.5H39.396L36.2514 22Z",
    fill: "#34A33D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1068 27.5L26.8096 27.5081L29.9622 33.0081L36.2514 33L33.1068 27.5Z",
    fill: "#95BC2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5486 22L39.396 16.5L42.5486 11L45.7013 16.5L42.5486 22Z",
    fill: "#30A966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7013 16.5L42.5486 11L45.7013 5.5L48.8459 11L45.7013 16.5Z",
    fill: "#008F41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8459 11L45.7013 5.5L48.8459 0L51.9985 5.5L48.8459 11Z",
    fill: "#95BC2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.396 27.5L36.2514 22L39.396 16.5L42.5486 22L39.396 27.5Z",
    fill: "#008F41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 308,
    height: 44,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.93980993d7b219d0a7164948cc5e7300.svg";
export { ForwardRef as ReactComponent };